import React, {forwardRef} from 'react';
import {useSelector} from 'react-redux';
import styled from 'styled-components';
import {labels} from '../../../../../../../../../util/utils';
import ResourceWithLinks from '../../../../../../../ResourceWithLink/ResourceWithLink';
import ViewItControlListItem from './ViewItControlListItem';

const ViewItControlsList = forwardRef((props, ref) => {
	const {allIdsSelector, bodyId, showUnrelatedItControls, showUnrelatedITSP} = props;
	const itControlIds = useSelector((state) => allIdsSelector(state, bodyId));
	const unrelatedItControlModalNoDataPlaceholder = showUnrelatedITSP
		? labels.unrelatedITSPModalNoDataPlaceholder
		: labels.unrelatedItGCModalNoDataPlaceholder;

	return (
		<StyledViewItControls>
			<section className="view-itcontrols-list customScrollbar">
				<>
					{itControlIds && itControlIds.length > 0 ? (
						<>
							{itControlIds.map((itControlId) => (
								<ViewItControlListItem
									key={itControlId}
									itControlId={itControlId}
									bodyId={bodyId}
									isUnrelatedItControl={showUnrelatedItControls}
								/>
							))}
						</>
					) : (
						<StyledNoItControlsPlaceholder placeholder={unrelatedItControlModalNoDataPlaceholder} />
					)}
				</>
			</section>
		</StyledViewItControls>
	);
});

const StyledViewItControls = styled.section`
	overflow: auto;
	height: 100%;
	display: flex;
	flex-direction: row;
	.view-itcontrols-list {
		width: 100%;
	}
`;

const StyledNoItControlsPlaceholder = styled(ResourceWithLinks)`
	color: var(--neutrals-900);
`;

ViewItControlsList.displayName = 'ViewItControls';

export default ViewItControlsList;
